// extracted by mini-css-extract-plugin
export default {"productGrid":"Y4-z","centerLink":"Z4-z","productSection":"_4-z","item":"a5-z","ctaButton":"b5-z"};